<template>
  <div>
    <div class="row mt-1">
      <div class="col-md-4 mb-2">
        <label :for="plannedActionInputId">
          {{ trans("examination.diagnosiskPlanedHeadline") }}
        </label>
        <DerSelectWithChildren
          :id="plannedActionInputId"
          v-model="searchFields.plannedDiagnosisId"
          :data-options="plannedDiagnoses"
          :data-placeholder="
            trans('examination.externalResourceSelectPlaceholder')
          "
        />
      </div>

      <div class="col-md-4 mb-2">
        <label :for="diagnosisInputId">
          {{ trans("examination.diagnosisCodeDermatoskopiskLabel") }}
        </label>
        <DerSelectWithChildren
          :id="diagnosisInputId"
          v-model="searchFields.dermatoscopicDiagnosisId"
          :data-options="dermatoscopicDiagnoses"
          :data-placeholder="
            trans('examination.externalResourceSelectPlaceholder')
          "
        />
      </div>

      <div class="col-md-4 mb-2">
        <label :for="differentialInputId">
          {{ trans("examination.diagnosisCodeDifferentialLabel") }}
        </label>
        <DerSelectWithChildren
          :id="differentialInputId"
          v-model="searchFields.differentialDiagnosisId"
          :data-options="differentialDiagnoses"
          :data-placeholder="
            trans('examination.externalResourceSelectPlaceholder')
          "
        />
      </div>

      <div class="col-md-4 mb-2">
        <label :for="histopathologicalInputId">
          {{ trans("examination.diagnosiscodeHistopatologiskLabel") }}
        </label>
        <DerSelectWithChildren
          :id="histopathologicalInputId"
          v-model="searchFields.histopathologicalDiagnosisId"
          :data-options="histopathologicalDiagnoses"
          :data-placeholder="
            trans('examination.externalResourceSelectPlaceholder')
          "
        />
      </div>

      <div class="col-md-4 mb-2">
        <label :for="histoPathologicalStatusInputId">
          {{ trans("examination.diagnosiscodeHistopatologiskStatusLabel") }}
        </label>
        <DerSelect
          :id="histoPathologicalStatusInputId"
          v-model="searchFields.histopathologicalStatusId"
          :data-options="histopathologicalStatuses"
          :data-get-option-value="(option) => option.id"
          :data-get-option-label="(option) => option.text"
          :data-placeholder="
            trans('examination.externalResourceSelectPlaceholder')
          "
        />
      </div>

      <div class="col-md-4 mb-2">
        <label>{{ trans("examination.tagsLabel") }}</label>
        <v-select
          v-model="searchFields.tags"
          name="tags"
          :options="tags"
          label="text"
          :reduce="(tag) => tag.id"
          :placeholder="trans('examination.externalResourceSelectPlaceholder')"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { v4 as uuidV4 } from "uuid";
import DerSelectWithChildren from "../Utils/DerSelectWithChildren.vue";
import DerSelect from "../Utils/DerSelect.vue";

const plannedActionInputId = uuidV4();
const diagnosisInputId = uuidV4();
const histopathologicalInputId = uuidV4();
const histoPathologicalStatusInputId = uuidV4();
const differentialInputId = uuidV4();
</script>
<script>
export default {
  props: ["searchFields", "searchOptions"],
  data() {
    return {
      dermatoscopicDiagnoses: [],
      plannedDiagnoses: [],
      histopathologicalDiagnoses: [],
      histopathologicalStatuses: [],
      differentialDiagnoses: [],
      tags: [],
    };
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    loadData: function () {
      axios
        .get("/api/internal/search/filter-lists/1")
        .then((data) => {
          let collection = data.data;

          this.dermatoscopicDiagnoses = collection.dermatoscopicDiagnoses;
          this.plannedDiagnoses = collection.plannedDiagnoses;
          this.histopathologicalDiagnoses =
            collection.histopathologicalDiagnoses;
          this.histopathologicalStatuses = collection.histopathologicalStatuses;
          this.differentialDiagnoses = collection.differentialDiagnoses;
          this.tags = collection.tags;
          this.loading = false;
        })
        .catch((error) => {
          this.userErrorMessage(error);
          this.loading = false;
        });
    },
  },
};
</script>
